<template>
  <div class="password">
    <a-form-model
      ref="ruleForm"
      class="ant-advanced-search-form"
      :model="form"
      :rules="rules"
    >
      <a-row :gutter="24">
        <a-col span="24">
          <a-form-model-item
            ref="old_password"
            prop="old_password"
            :label="$t('user-account-password/old')"
            required
          >
            <a-input v-model="form.old_password" />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item
            ref="password"
            prop="password"
            :label="$t('user-account-password/new')"
            required
          >
            <a-input-password
              v-model="form.password"
              :placeholder="$t('admin-password-password/8-characters')"
            />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item
            ref="password_confirmation"
            prop="password_confirmation"
            :label="$t('user-account-password/reEnter')"
            required
          >
            <a-input-password v-model="form.password_confirmation" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <footer>
      <a-button @click="save">
        {{ $t('user-tools/save') }}
      </a-button>
    </footer>
  </div>
</template>
<script>
import { changePassword } from '@/api/login'
import zh from '@/lang/zh.json'
import en from '@/lang/en.json'
import { getLKey } from '@/utils/auth'

const i18n = { zh, en }
const lang = getLKey()

const password = []
function passwordValidate(rule, value, callback) {
  console.log(password)
  if (value) {
    if (value.length < 8) return callback(i18n[lang]['admin-password-password/8-bit'])
    password[rule.field === 'password' ? 0 : 1] = value
    if (password[0] && password[1] && password[0] !== password[1]) {
      callback(i18n[lang]['admin-password-password/different-passwords'])
    } else {
      callback()
    }
  } else {
    callback(i18n[lang]['admin-password-password/please-enter'])
  }
}

export default {
  data() {
    return {
      form: {
        old_password: '',
        password: '',
        password_confirmation: ''
      },
      rules: {
        old_password: [
          { required: true, message: this.$t('admin-password-password/original'), trigger: ['change', 'blur'] },
          { min: 8, max: 32, message: this.$t('admin-password-password/interval'), trigger: ['change', 'blur'] }
        ],
        password: [
          { validator: passwordValidate, trigger: ['change', 'blur'], validateFirst: true }
        ],
        password_confirmation: [
          { validator: passwordValidate, trigger: ['change', 'blur'], validateFirst: true }
        ]
      }
    }
  },
  created() {
  },
  methods: {
    save() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          const data = JSON.parse(JSON.stringify(this.form))
          changePassword(data).then(() => {
            this.$message.success({ content: i18n[lang]['admin-password-password/savey'], key: 'message', duration: 4 })
          }).catch(res => {
            console.error(res)
          })
        } else {
          this.$message.warning({ content: i18n[lang]['view-components-components/perfect'], key: 'message', duration: 4 })
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
  footer {
    width: 100%;
    height: 70px;
    text-align: right;
    padding: 19px 24px;
    background: #ffffff;
    position: fixed;
    bottom: 0;
    right: 0;
  }

  footer button {
    margin-left: 16px;
  }
</style>
